/**
 * Paths comerciales por módulo — sin importar modulo_* (evita carga React en Jest).
 * Mantener alineado con modulo_visor.js, modulo_laboral.js y tramitesService.js.
 */
import { isVisorNavPath } from "./entitlementsFromSystemInfo";

const VISOR_ENTITLEMENT_EXACT = new Set([
  "/visor/inicio",
  "/clientes",
  "/visores-sat",
  "/visores-sat-xml",
  "/visor-ingresos",
  "/visor-egresos",
  "/visor-nominas",
  "/confronta",
  "/confronta-egresos",
  "/confronta-nominas",
  "/visor-confronta",
  "/carga-manual",
  "/carga-automatica",
  "/descarga-documentos-fiscales",
  "/carga-excel",
  "/carga-csv",
  "/carga-plantilla-excel",
  "/carga-modo-complemento",
]);

const LABORAL_ENTITLEMENT_PATHS = new Set([
  "/laboral/inicio",
  "/laboral/validar-inscribir",
  "/datos-maestros/validador-check-id",
  "/datos-maestros/validacion-rfc-sat",
  "/clientes",
  "/registros-patronales-certificados",
  "/catalogo-trabajadores",
  "/expedientes-laborales",
  "/control-repse",
  "/confronta-trabajadores-imss",
  "/confronta-emisiones-imss",
]);

const TRAMITES_ENTITLEMENT_PATHS = new Set([
  "/tramites/inicio",
  "/tramites/validacion-datos",
  "/tramites/validador-nss",
  "/tramites/validacion-rfc-sat",
  "/datos-maestros/validacion-rfc-sat",
  "/tramites/inscripcion-trabajadores-sat",
  "/tramites/inscripcion-trabajadores-imss",
  "/tramites-fiscales",
  "/validador-rfc-sat",
  "/validador-nss-imss",
  "/inscripcion-trabajadores-sat",
  "/inscripcion-trabajadores-imss",
  "/validacion-rfc-sat",
  "/asistente-validacion-sat",
]);

const DESPACHO_ENTITLEMENT_PATHS = new Set([
  "/despacho/inicio",
  "/despacho/clientes",
  "/despacho/auxiliares",
  "/despacho/tareas",
  "/despacho/calendario",
  "/despacho/mensajes",
  "/despacho/reportes",
  "/despacho/configuracion-modulo",
]);

const MATERIALIDAD_ENTITLEMENT_PATHS = new Set([
  "/materialidad/inicio",
  "/materialidad/expediente",
  "/tramites/materialidad",
]);

export function isVisorCommercialPath(pathname) {
  const path = String(pathname || "").split("?")[0];
  if (VISOR_ENTITLEMENT_EXACT.has(path)) return true;
  return isVisorNavPath(path);
}

export function isLaboralCommercialPath(pathname) {
  const path = String(pathname || "").split("?")[0];
  return LABORAL_ENTITLEMENT_PATHS.has(path);
}

export function isTramitesCommercialPath(pathname) {
  const path = String(pathname || "").split("?")[0];
  if (path === "/tramites/materialidad" || path.startsWith("/materialidad/")) return false;
  if (TRAMITES_ENTITLEMENT_PATHS.has(path)) return true;
  return path.startsWith("/tramites-fiscales/");
}

export function isMaterialidadCommercialPath(pathname) {
  const path = String(pathname || "").split("?")[0];
  if (MATERIALIDAD_ENTITLEMENT_PATHS.has(path)) return true;
  return path.startsWith("/materialidad/");
}

export function isDespachoCommercialPath(pathname) {
  const path = String(pathname || "").split("?")[0];
  if (DESPACHO_ENTITLEMENT_PATHS.has(path)) return true;
  return path.startsWith("/despacho/");
}
